import React, { useRef, useEffect, useState } from 'react';
import { VariableSizeList as VirtualList } from 'react-window';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import { Button } from 'antd';
import ListItem from '../listItem';
import { getContactItemKey, isOrg } from '@web-common/components/util/contact';
import styles from './index.module.scss';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import { getIn18Text } from 'api';
const ContactList = props => {
    const { useContactId, showPosition, showAvatar = true, showCheckbox = false, showDelete = true, showFooter = true, selectList: defaultSelectList = [], onDelete, onCancel, onSure, needScrollBottom = true, canSure = true, firstPositionNotDelEmail, } = props;
    const [selectMap, setSelectMap] = useState(new Map());
    const listRef = useRef(null);
    const getSelectList = () => {
        return [...selectMap.values()];
    };
    const handleListDelete = (data) => {
        selectMap.delete(getContactItemKey(data, useContactId));
        setSelectMap(selectMap);
        onDelete && onDelete(getSelectList(), [data]);
    };
    const handleListCancel = () => {
        onCancel && onCancel(getSelectList());
    };
    const handleListSure = () => {
        onSure && onSure(getSelectList());
    };
    useContactItemEffect(defaultSelectList, () => {
        var _a;
        const itemMap = new Map();
        defaultSelectList.forEach(item => {
            const key = isOrg(item) ? item.id : getContactItemKey(item, useContactId);
            itemMap.set(key, item);
        });
        (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.resetAfterIndex(0);
        setSelectMap(itemMap);
    }, useContactId);
    useEffect(() => {
        needScrollBottom &&
            setTimeout(() => {
                var _a;
                (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(selectMap.size);
            }, 500);
    }, [needScrollBottom, listRef]);
    const selectList = getSelectList();
    const renderList = () => {
        if (selectList.length) {
            return (React.createElement(AutoSizer, null, ({ width, height }) => (React.createElement(VirtualList, { ref: listRef, itemSize: index => {
                    var _a;
                    const _item = selectList[index];
                    if (isOrg(_item)) {
                        return 52;
                    }
                    else {
                        const item = _item;
                        return showPosition && ((_a = item === null || item === void 0 ? void 0 : item.position) === null || _a === void 0 ? void 0 : _a.length) ? 72 : 52;
                    }
                }, itemCount: selectMap.size, height: height, width: width, className: styles.vScrollList }, ({ index, style }) => {
                const item = selectList[index];
                const isOrgItem = isOrg(item);
                const key = isOrgItem ? item.id : getContactItemKey(item, useContactId);
                const _showDelete = showDelete && (isOrgItem || firstPositionNotDelEmail !== item.email);
                return (React.createElement("div", { className: styles.listItem, key: key, style: Object.assign({}, style) },
                    React.createElement(ListItem, { testId: "contact_selectedList_item", type: "normal", showPosition: showPosition && !isOrgItem, showAvatar: showAvatar, showCheckbox: showCheckbox, showDelete: _showDelete, item: item, isLeaf: !isOrgItem, onDelete: handleListDelete })));
            }))));
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { className: styles.selectedListContainer, "data-test-id": "contact_selectedList" },
        React.createElement("div", { className: styles.listTitle },
            getIn18Text('YIXUAN'),
            "\uFF08",
            React.createElement("span", { "data-test-id": "contact_selectedList_count" }, selectMap.size),
            " \uFF09"),
        React.createElement("div", { className: styles.listWrap }, renderList()),
        showFooter && (React.createElement("div", { className: styles.listFooter },
            React.createElement(Button, { "data-test-id": "contact_selectedList_btn_cancel", type: "default", className: styles.listFooterBtn, onClick: () => {
                    handleListCancel();
                } }, getIn18Text('QUXIAO')),
            React.createElement(Button, { "data-test-id": "contact_selectedList_btn_save", disabled: !canSure, type: "primary", className: styles.listFooterBtn, onClick: () => {
                    handleListSure();
                } }, getIn18Text('QUEDING'))))));
};
export default ContactList;
